export const cameraAlertKey = name => String(name || "").trim().replace(/ /g, "_");
export const cameraAlertTimestamp = alert => {
  const value = alert.occurred_at || alert.alert_timestamp || alert.timestamp || alert.created_at;
  return typeof value === "number" ? value : Date.parse(value);
};

// Track first reception, not render time. Repeated polls and layout changes cannot replay an event.
export const createCameraAlertTracker = (initialSeen = [], onSeen = null) => {
  const seen = new Map(Array.isArray(initialSeen) ? initialSeen.filter(entry => Array.isArray(entry) && typeof entry[0] === "string" && Number.isFinite(entry[1])) : []);
  const latest = new Map();
  return (alerts, now = Date.now()) => {
    let changed = false;
    for (const [key, received] of seen) if (now - received > 15 * 60 * 1000) { seen.delete(key); changed = true; }
    const fresh = {};
    [...alerts].sort((a, b) => cameraAlertTimestamp(a) - cameraAlertTimestamp(b)).forEach(alert => {
      const camera = cameraAlertKey(alert.camera_name);
      const timestamp = cameraAlertTimestamp(alert);
      const type = String(alert.detection_type || alert.alert_type || "").toLowerCase();
      if (!camera || !type || !Number.isFinite(timestamp) || timestamp < now - 120000 || timestamp > now + 10000) return;
      const fingerprint = `${camera}:${type}:${timestamp}`;
      const identity = alert.id ? `id:${alert.id}` : `${camera}:${type}:${alert.legacy_alert_id || timestamp}:${timestamp}`;
      if (seen.has(identity) || seen.has(fingerprint)) return;
      seen.set(identity, now);
      seen.set(fingerprint, now);
      changed = true;
      if (timestamp < (latest.get(camera) || 0)) return;
      latest.set(camera, timestamp);
      fresh[camera] = { alert: { ...alert, detection_type: type, occurred_at: new Date(timestamp).toISOString() }, receivedAt: now };
    });
    if (changed && onSeen) onSeen([...seen]);
    return fresh;
  };
};

export const expireCameraAlerts = (active, durationSeconds, now = Date.now()) =>
  Object.fromEntries(Object.entries(active).filter(([, event]) => event.persistent || event.receivedAt + durationSeconds * 1000 > now));
